import { WidgetAd } from '@scorenco/components';
import { Types } from '@scorenco/core';

import { useAutoCloseProgress } from './useAutoCloseProgress';
import { usePopupAdEligibility } from './usePopupAdEligibility';

type WidgetPopupAdProps = {
  widget: Types.Widgets_Widget;
  delayMs?: number;
  cooldownHours?: number;
  overlayDurationMs?: number;
};

export const WidgetPopupAd = ({
  widget,
  delayMs = 0,
  cooldownHours = 0,
  overlayDurationMs = 4000,
}: WidgetPopupAdProps) => {
  const { isOpen, setIsOpen } = usePopupAdEligibility({
    widget,
    delayMs,
    cooldownHours,
  });

  useAutoCloseProgress({
    isOpen,
    durationMs: overlayDurationMs,
    onClose: () => {
      console.log('WidgetPopupAd: auto-closing after duration');
      setIsOpen(false);
    },
  });

  if (!isOpen) {
    return (
      <WidgetAd
        impressionEnabled={true}
        widgetId={widget.id}
        variant="footer"
      />
    );
  }

  return (
    <WidgetAd impressionEnabled={true} widgetId={widget.id} variant="popup" />
  );
};
